import styled from 'styled-components'
import { Alert } from '@fe-toolkit/web-components/ssr'

const LeftAlignedAlert = styled(Alert)`
  &&& > div {
    margin-left: 0;
  }
`

export default LeftAlignedAlert
